import { render, staticRenderFns } from "./FormControlTypeSelect.vue?vue&type=template&id=b6f7c47c&scoped=true"
import script from "./FormControlTypeSelect.vue?vue&type=script&lang=js"
export * from "./FormControlTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f7c47c",
  null
  
)

export default component.exports